export default "__VITE_ASSET__hesjXnvn__"